const LoadingFallback = () => (
  <div className="w-full h-32 flex items-center justify-center">
    <div className="animate-pulse">Loading...</div>
  </div>
)

export default LoadingFallback
